import React, { useState, useRef } from "react"
import { Editor } from "@tinymce/tinymce-react"
import EmailApi from "../../../Api/emailApi"
import "./AppAddEmailTemplate.scss"
import { useNavigate } from "react-router-dom"
import { Toast } from "primereact/toast"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"

const AppAddEmailTemplate = () => {
  document.title = "Add Email Template"
  const [addEmailTemplateData, setAddEmailTemplateData] = useState({
    title: "",
    subject: "",
    template: "",
  })
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")
  const accessToken = localStorage.getItem("accessToken")
  const navigate = useNavigate()
  const toast = useRef(null)
  const breadcrumbItems = [
    { label: "Pixwik", link: "/" },
    { label: "Email Template", link: "/EmailTemplateTable" },
    { label: "Add Email Template" },
  ]
  const handleBreadcrumbClick = link => {
    if (link !== "#") {
      navigate(link)
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    setLoading(true)
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    EmailApi.addEmailTemplate(addEmailTemplateData, config)
      .then(res => {
        setAddEmailTemplateData({
          title: "",
          subject: "",
          template: "",
        })
        setMessage("Template added successfully!")
        setLoading(false)
        setTimeout(() => {
          navigate(-1)
        }, 1000)
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Template added successfully!",
          life: 3000,
        })
        // toast.success("Template added successfully!");
      })
      .catch(err => {
        setMessage(err.response.data.error || "An error occurred!")
        setLoading(false)
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: err.response.data.error || "An error occurred!",
          life: 3000,
        })
        // toast.error("Template not added!");
      })
  }

  return (
    <>
      <Toast ref={toast} position="top-right" life="3000" />
      <div className="add-email-template-form">
        <CustomBreadCrumb
          data={breadcrumbItems}
          pageTitle="Add Email Template"
          handleClick={handleBreadcrumbClick}
        />
        <form onSubmit={handleSubmit}>
          <div className="add-email-template-inp ">
            <label className="label m-0">Title</label>
            <input
              type="text"
              value={addEmailTemplateData.title}
              onChange={e =>
                setAddEmailTemplateData({
                  ...addEmailTemplateData,
                  title: e.target.value,
                })
              }
              className="inp-field-box p-2 border rounded mt-1"
              required
            />
          </div>

          <div className="add-email-template-inp">
            <label className="label m-0">Subject</label>
            <input
              type="text"
              value={addEmailTemplateData.subject}
              onChange={e =>
                setAddEmailTemplateData({
                  ...addEmailTemplateData,
                  subject: e.target.value,
                })
              }
              className="inp-field-box p-2 border rounded mt-1"
              required
            />
          </div>

          <div className="add-email-template-template">
            <label className="label m-0">HTMLl Template</label>
            <Editor
              apiKey="t7g4d6ut5ygdvwif7tp5bwyysui56413aomjuh8kusvw5qgv"
              value={addEmailTemplateData.template}
              onEditorChange={content =>
                setAddEmailTemplateData({
                  ...addEmailTemplateData,
                  template: content,
                })
              }
              init={{
                height: 500,
                menubar: true,
                plugins: [
                  "advlist",
                  "autolink",
                  "lists",
                  "link",
                  "image",
                  "charmap",
                  "preview",
                  "anchor",
                  "code",
                  "fullscreen",
                  "table",
                  "help",
                  "wordcount",
                ],
                toolbar:
                  "undo redo | formatselect | " +
                  "bold italic backcolor | alignleft aligncenter " +
                  "alignright alignjustify | bullist numlist outdent indent | " +
                  "removeformat | code | help",
                content_css: false,
                content_style: "",
                valid_elements: "*[*]",
                extended_valid_elements: "style,link[href|rel]",
                custom_elements: "~style",
                verify_html: false,
                cleanup: false,
                convert_fonts_to_spans: false,
                remove_trailing_brs: false,
                force_br_newlines: false,
                force_p_newlines: false,
                forced_root_block: false,
                valid_children: "+body[style],+html[style]",
                element_format: "html",
                entities_encode: false,
                entity_encoding: "raw",
                preserve_cdata: true,
                protect: [
                  /<![\s\S]*?>/g,
                  /<\?[\s\S]*?\?>/g,
                  /<style[\s\S]*?style>/g,
                ],
                valid_styles: {
                  "*": "*",
                },
                paste_as_text: false,
                paste_enable_default_filters: false,
                setup: function (editor) {
                  editor.on("BeforePaste", function (e) {
                    e.preventDefault()
                    const text =
                      e.clipboardData.getData("text/html") ||
                      e.clipboardData.getData("text")
                    editor.execCommand("mceInsertContent", false, text)
                  })
                },
              }}
            />
          </div>

          <div className="save-cancel-btn">
            <button
              type="submit"
              disabled={loading}
              className="save-cancel-btn-btn"
            >
              {loading ? "Saving..." : "Save Template"}
            </button>
            <button
              type="button"
              className="save-cancel-btn-btn"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export default AppAddEmailTemplate
